export const PAYMENT_PRODUCT_ICONS:  { [key: string]: string } = {
  car: 'options-hirecar',
  home: 'house-home',
  travel: 'travel-holiday',
  mobile: 'marketing-optionals',
};

export const PAYMENT_HERO_ICONS:  { [key: string]: string } = {
  credit_card: 'management-payment',
  direct_debit: 'management-bankaccount'
};

export const PAYMENT_METHODS:  { [key: string]: any } = {
  label: {
    visa: 'Visa',
    mastercard: 'MasterCard',
    amex: 'American Express'
  },
  icon: {
    visa: 'Visa-Grey-Box.svg',
    mastercard: 'Mastercard-Grey-Box.svg',
    amex: 'American-Express-Grey-Box.svg'
  }
};
